import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import { Descriptions, Badge, Collapse, Button, Tag } from "antd";
import { Redirect } from "react-router-dom";
const { Panel } = Collapse;

function App(props) {
  const [response, setResponse] = useState();
  const [deleted, setDeleted] = useState(false);
  const deleteAction = () => {
    Axios.delete(baseUrl + "products/" + props.match.params.id)
      .then(response => {
        setDeleted(true);
      })
      .catch(function(error) {});
  };
  useEffect(() => {
    Axios.get(baseUrl + "products/" + props.match.params.id)
      .then(response => {
        setResponse(response.data);
      })
      .catch(function(error) {});
  }, []);
  if (deleted) {
    return <Redirect to="/products/list" />;
  }
  if (!response) {
    return <div>Loading</div>;
  }
  console.log(response, "PROPS");
  return (
    <div style={{ padding: "100px 0" }}>
      <Descriptions title="Product Info" bordered layout="vertical">
        <Descriptions.Item label="Product Id" span={3}>
          {response._id}
        </Descriptions.Item>
        <Descriptions.Item label="Product Name">
          {response.name}
        </Descriptions.Item>
        <Descriptions.Item label="Mac Address">
          {response.macId}
        </Descriptions.Item>

        <Descriptions.Item label="Current Ip">
          {response.currentIp}
        </Descriptions.Item>
        <Descriptions.Item label="Banner Image" span={1}>
          <img
            alt={"banner1"}
            style={{ width: "50%" }}
            src={response.bannerImage}
          ></img>
        </Descriptions.Item>
        <Descriptions.Item label="Company Logo" span={2}>
          <div style={{ backgroundColor: "#000" }}>
            <img
              alt={"company1"}
              style={{ height: "100%", width: "70%" }}
              src={response.companyLogo}
            ></img>
          </div>
        </Descriptions.Item>

        <Descriptions.Item label="Components" span={3}>
          <Collapse bordered={false} defaultActiveKey={[0]}>
            {response.components.map((comp, id) => (
              <Panel header={`${comp.name}`} key={id}>
                <Descriptions bordered layout="horizontal">
                  <Descriptions.Item label="Component Name">
                    {comp.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Component Label">
                    {comp.label}
                  </Descriptions.Item>
                  <Descriptions.Item label="Component Type">
                    <Tag color="magenta">{comp.type}</Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Component Active Code" span={3}>
                    {comp.activeCode}
                  </Descriptions.Item>
                  <Descriptions.Item label="Component Deactive Code" span={3}>
                    {comp.deactiveCode}
                  </Descriptions.Item>
                </Descriptions>
              </Panel>
            ))}
          </Collapse>
        </Descriptions.Item>

        <Descriptions.Item label="Status" span={3}>
          <Badge status={response.status} text={response.status} />
        </Descriptions.Item>
      </Descriptions>
      <div style={{ paddingTop: 50 }}>
        <Button type="primary">Edit Product</Button>
        <Button type="danger" onClick={() => deleteAction()}>
          Delete Product
        </Button>
      </div>
    </div>
  );
}

export default App;
